import React, { useState } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { useRecoilState, useRecoilValue } from 'recoil';
import { vehicleState } from './states';

import { StyledButton } from './components/shared/StyledButton';
import aiIcon from './assets/ai-icon.png';

import './AcceptTerms.css';
import ExternalLink from './components/shared/ExternalLink';

export interface props {
    onProceed: React.MouseEventHandler<HTMLButtonElement>
}

const AcceptTerms = ({ onProceed }: props) => {
    const [isChecked, setIsChecked] = useState(false);
    const vehicle = useRecoilValue(vehicleState);

    const handleCheckboxChange = () => {
        let hasAcceptedTermKey = "hasAcceptedTermKey";

        setIsChecked(!isChecked);
        localStorage.setItem(hasAcceptedTermKey, "accepted");
    };

    return (
        <Container fluid={true} className='terms-div'>
            <Row>
            </Row>
            <Row>
            <label>Please accept the terms to start chat</label>
                <label className='overlay-label'>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        className='accept-checkbox'
                    />
                    I accept the following terms and conditions

                    <div className='link-row'>
                        <ExternalLink title="Privacy Policy" url="https://www.innova.com/pages/privacy-policy?ad=aaa" />
                        <ExternalLink title="Terms of Use" url="https://www.innova.com/pages/terms-of-use?ad=aaa" />
                    </div>
                </label>
            </Row>
            <Row>
                <div className='proceed-button'>
                    <StyledButton
                        disabled={!isChecked || !vehicle.make || !vehicle.model || !vehicle.year}
                        backgroundColor='#D32F2F'
                        onClick={onProceed}
                        buttonText={'Start Chat'}
                        image={<img src={aiIcon} alt="AI Icon" style={{width:'24px', height: '24px'}}  />} />
                </div>
            </Row>
        </Container>
    );
};

export default AcceptTerms;
